@if (uploader.queue.length) {
  <div class="uploader-queue">
    <div class="uploader-queue-header d-flex justify-content-between">
      <div style="line-height: 22px">
        @if (isUploading) {
          <span>Caricamento in corso...</span>
        }
        @if (isPending) {
          <span>Caricamento in attesa</span>
        }
        @if (isSuccess) {
          <span>Caricamento completato</span>
        }
        @if (isError) {
          <span>Caricamento non completato</span>
        }
      </div>
      <div class="uploader-queue-actions">
        @if (isListVisible()) {
          <button class="btn btn-sm" type="button" (click)="hideList()">
            <fa-icon [icon]="faAngleDown"></fa-icon>
          </button>
        }
        @if (!isListVisible()) {
          <button class="btn btn-sm" type="button" (click)="showList()">
            <fa-icon [icon]="faAngleUp"></fa-icon>
          </button>
        }
        <button class="btn btn-sm" type="button" (click)="closeDialog()">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>
    </div>
    @if (hasItems && isListVisible()) {
      <ul class="uploader-queue-file-list">
        @for (item of uploader.queue; track item; let i = $index) {
          <li class="uploader-queue-file d-flex justify-content-between">
            <div class="file-name" [ngbTooltip]="item?.file?.name" [ngClass]="{'text-danger': item.isError}">
              {{item?.file?.name}}
            </div>
            <div class="uploader-queue-icon">
              <!--[spin]="true"-->
              @if (item.isUploading) {
                <fa-icon [icon]="faCircleNotch"></fa-icon>
              }
              @if (item.isError) {
                <fa-icon [icon]="faTimesCircle" class="text-danger" [ngbTooltip]="getErrorMessage(item)"></fa-icon>
              }
              @if (item.isSuccess) {
                <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
              }
            </div>
          </li>
        }
      </ul>
    }
    <div class="uploader-queue-summary">
      <div class="d-flex justify-content-between">
        <div>
          @if (!isSuccess && !isError && isProcessing) {
            <span>Elaborazione in corso&hellip;</span>
          }
          @if (!isSuccess && !isError && !isProcessing) {
            <span>{{progress}} completo ({{completedItems}}
            di {{totalItems}} file)</span>
          }
          @if (isSuccess) {
            <span>Caricamento completato</span>
          }
          @if (isError) {
            <span>Errore nel caricamento</span>
          }
        </div>
        <div class="uploader-queue-icon">
          <!--[spin]="true"-->
          @if (isUploading) {
            <fa-icon [icon]="faCircleNotch"></fa-icon>
          }
          @if (isError) {
            <fa-icon [icon]="faTimesCircle" class="text-danger"></fa-icon>
          }
          @if (isSuccess) {
            <fa-icon [icon]="faCheckCircle" class="text-success"></fa-icon>
          }
        </div>
      </div>
    </div>
  </div>
}
